import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ApiService } from './api.service';
import { environment } from '@env/environment';
import { NotificationService } from '../notification.service';
import { HttpEvent, HttpHeaders } from '@angular/common/http';
import { FileUpload, IFileUpload } from '@app/infrastructure/models/file';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  private controllerRoute: string = 'files';
  private url: string = `${environment.apiRoute}`;

  constructor(
    private apiService: ApiService,
    private notificationService: NotificationService,
  ) {
    this.url = `${environment.apiRoute}/${this.controllerRoute}`;
  }

  public uploadFiles(files: FormData): Observable<IFileUpload[]> {
    const endpoint = this.url;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data');
    return this.apiService
      .post<IFileUpload[], FormData>(endpoint, files, { headers })
      .pipe(
        tap((result) => {
          const message = `Images Added.`;
          return this.notificationService.showSuccess([message]);
        }),
      );
  }

  public directS3Upload(
    fileUpload: FileUpload,
    file: File,
  ): Observable<HttpEvent<unknown>> {
    return this.apiService.put<HttpEvent<unknown>, File>(
      fileUpload.signedUrl,
      file,
      {},
    );
  }

  public getFileUpload(id: string): Observable<FileUpload> {
    const endpoint = `${this.url}/${id}`;
    return this.apiService.get<FileUpload>(endpoint);
  }

  public createFileUpload(files: FileList): Observable<FileUpload> {
    const endpoint = this.url;
    const file = files[0];
    if (file) {
      const upload: FileUpload = new FileUpload();
      Object.assign(upload, {
        fileName: file.name,
        fileSize: file.size,
        fileMimeType: file.type,
      });
      return this.apiService.post<FileUpload, FileUpload>(endpoint, upload);
    }
  }

  public createNewFileUpload(file: File): Observable<FileUpload> {
    const endpoint = this.url;
    if (file) {
      const upload: FileUpload = new FileUpload();
      Object.assign(upload, {
        fileName: file.name,
        fileSize: file.size,
        fileMimeType: file.type,
      });
      return this.apiService.post<FileUpload, FileUpload>(endpoint, upload);
    }
  }

  public uploadFilesWithProgress(
    files: FormData,
  ): Observable<HttpEvent<unknown>> {
    const endpoint = this.url;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data');
    return this.apiService.post<HttpEvent<unknown>, FormData>(endpoint, files, {
      headers,
      reportProgress: true,
      observe: 'events',
    });
  }
}
